import { POSTHOG_FEATURES } from "../constants/feature-flags"
import usePostHogFeatureFlags from "./posthog-feaures"

/**
 * The Meta Budgets page reads campaigns and writes budgets straight through
 * the Meta Marketing API (no Cube). It is hidden behind the
 * `meta-budget-editor` PostHog flag; the sidebar entry and the route both
 * read it, so nav and route agree.
 */
export default function useMetaBudgetEditorAccess() {
  const isFeatureFlagEnabled = usePostHogFeatureFlags(
    POSTHOG_FEATURES.META_BUDGET_EDITOR,
  )

  return { hasAccess: isFeatureFlagEnabled }
}
